// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"6b26c387","787":"a1ddc8d4"}[chunkId] + ".chunk.js";
};